import { createProvideInject } from '@collector/shared-ui'

import { PitchPenaltyOverlayConfig } from '../configuration'

export const [
  providePitchPenaltyOverlayConfig,
  injectPitchPenaltyOverlayConfig,
] = createProvideInject<PitchPenaltyOverlayConfig>('pitchPenaltyOverlayConfig')
